import app from '@/app';
import templateUrl from './plans-clear-button.html';

var component = {
	templateUrl,
	require: {
		form: '^form'
	},
	bindings: {
		soft: '<',
		disabled: '<',
		readonly: '<',
		onAccept: '&',
		onReject: '&'
	}
};

app.component('prPlansClearButton', component);
